import { FC } from 'react';
import { IconProps } from 'types';

export const ChevronIcon: FC<IconProps> = ({
  width = 30,
  height = 30,
  fill = '#FFFFFF',
  className,
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 10.679C15.296 10.6874 15.5666 10.7973 15.7864 11.0341L22.2131 17.6129C22.3991 17.799 22.5006 18.0357 22.5006 18.3148C22.5006 18.8729 22.0608 19.321 21.5027 19.321C21.2322 19.321 20.97 19.2111 20.7755 19.0166L15.0085 13.0889L9.22455 19.0166C9.03006 19.2027 8.77638 19.321 8.49733 19.321C7.93923 19.321 7.49951 18.8729 7.49951 18.3148C7.49951 18.0357 7.60098 17.799 7.78702 17.6129L14.2221 11.0341C14.4504 10.7973 14.7041 10.679 15 10.679Z"
      fill={fill}
    />
  </svg>
);
